import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-status-reject",
  templateUrl: "./status-reject.component.html",
  // styleUrls: ['./status-reject.component.css']
})
export class StatusRejectComponent implements OnInit {
  @Input() content: any;
  statusReject = [];

  constructor(public dialogRef: NgbActiveModal) {}

  ngOnInit() {
    // this.statusReject = this.content;
  }
  close() {
    this.dialogRef.close({ success: false });
  }
  confirmClose() {
    this.dialogRef.close({ success: true });
  }
}
